<template>
	<div class="omapi-card-setting-section omapi-card-setting-section-cookies">
		<header>
			<h3>Enable Global Cookie</h3>
		</header>
		<div>
			<div class="omapi-input-wrap omapi-input-wrap-column">
				<!-- eslint-disable max-len -->
				<common-tooltip
					tooltip="Once any campaign has been closed, no campaigns will appear on your site until the cookie expires. Turning off (or setting to 0) will disable."
				>
					<label for="show-interactive-cookie-setting">Global Interaction Cookie</label>
				</common-tooltip>
				<!-- eslint-enable max-len -->

				<p class="omapi-input-description">
					Once any campaign has been closed, no campaigns will appear on your site until the cookie expires.
					Turning off (or setting to 0) will disable.
				</p>

				<div class="omapi-horizontal-label">
					<common-toggle-input id="show-interactive-cookie-setting" v-model="showInteractiveCookieSetting" />
					<div
						:style="{ visibility: showInteractiveCookieSetting ? 'visible' : 'hidden' }"
						class="omapi-horizontal-label"
					>
						<label
							>Days:
							<input
								type="number"
								class="omapi-input"
								placeholder="0"
								min="0"
								name="globalInteractionCookie"
								:value="globalInteractionCookie"
								@input="setValue"
						/></label>
					</div>
				</div>
			</div>
			<div class="omapi-input-wrap">
				<!-- eslint-disable max-len -->
				<common-tooltip
					tooltip="Once any campaign has been converted, no campaigns will appear on your site until the cookie expires. Turning off (or setting to 0) will disable."
				>
					<label for="show-success-cookie-setting">Global Success Cookie:</label>
				</common-tooltip>
				<!-- eslint-enable max-len -->
				<p class="omapi-input-description">
					Once any campaign has been converted, no campaigns will appear on your site until the cookie
					expires. Turning off (or setting to 0) will disable.
				</p>

				<div class="omapi-horizontal-label">
					<common-toggle-input id="show-success-cookie-setting" v-model="showSuccessCookieSetting" />
					<div
						:style="{ visibility: showSuccessCookieSetting ? 'visible' : 'hidden' }"
						class="omapi-horizontal-label"
					>
						<label
							>Days:
							<input
								type="number"
								class="omapi-input"
								placeholder="0"
								min="0"
								name="globalSuccessCookie"
								:value="globalSuccessCookie"
								@input="setValue"
						/></label>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="js">
export default {
	props: {
		globalInteractionCookie: {
			type: [String, Number, Boolean],
			required: true,
		},
		globalSuccessCookie: {
			type: [String, Number, Boolean],
			required: true,
		},
	},
	data() {
		return {
			showInteractiveCookieSetting: false,
			showSuccessCookieSetting: false,
		};
	},
	watch: {
		globalInteractionCookie(newValue) {
			if (0 < newValue) {
				this.showInteractiveCookieSetting = true;
			}
		},
		globalSuccessCookie(newValue) {
			if (0 < newValue) {
				this.showSuccessCookieSetting = true;
			}
		},
		showInteractiveCookieSetting(newVal) {
			this.$emit('toggle', 'globalInteractionCookie', newVal);
		},
		showSuccessCookieSetting(newVal) {
			this.$emit('toggle', 'globalSuccessCookie', newVal);
		},
	},
	mounted() {
		if (this.globalInteractionCookie) {
			this.showInteractiveCookieSetting = true;
		}
		if (this.globalSuccessCookie) {
			this.showSuccessCookieSetting = true;
		}
	},
	methods: {
		setValue(event) {
			// Don't allow null or negative values.
			if (!event.target.value || 0 > event.target.value) {
				event.target.value = 0;
			}
			this.$emit('input', event);
		},
	},
};
</script>
<style lang="scss">
.omapi-horizontal-label {
	display: flex;
	align-items: center;
	margin: 5px 0;

	.omapi-horizontal-label {
		margin: 0;
	}

	.omapi-toggle {
		margin-right: 20px;
	}

	[type='number'] {
		width: 75px !important;
		margin: 0 0 0 2px !important;
	}
}
.omapi-screen .omapi-card-setting-section-cookies {
	.omapi-input-wrap .omapi-input-description {
		line-height: 150%;
	}
}
</style>
